import BaseModel from './BaseModel';

/** Class representing an user. */
class Payment extends BaseModel {}

export default Payment;
